export default __webpack_public_path__ + "static/media/Silver.34508a70.svg";